'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/HubUsers';
const INIT_STATE = {
  users: [],
  requestState: RequestState.NOT_REQUESTED
};
export function hubUsers(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_HUB_USERS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_HUB_USERS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_HUB_USERS:
      return Object.assign({}, state, {
        users: action.hubUsers.map(hubUser => {
          const ownedAddressHubUser = action.ownedAddresses.find(ownedAddress => hubUser.email === ownedAddress.content);
          return Object.assign({}, hubUser, {
            verified: ownedAddressHubUser ? ownedAddressHubUser.isVerified : hubUser.verified
          });
        })
      });
    case Actions.FAILED_GETTING_HUB_USERS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}